import { SendRules, Site } from 'sections/client-management/entities';

export function getSendRulesUpdatedSite(site: Site, sendRulesEnabled: boolean, sendRules: SendRules) {
  if (sendRulesEnabled) {
    return {
      ...site,
      sendRules,
    };
  } else {
    const { sendRules, ...siteWithoutSendRules } = site;
    return siteWithoutSendRules;
  }
}
